import { Breadcrumbs, Link, Typography } from "@mui/material";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const ConvertPathText = (text) => {
  return text
    .replace(/-/g, " ")
    .replace(/oe/g, "ö")
    .replace(/ae/g, "ä")
    .replace(/ue/g, "ü")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default function NextBreadcrumbs({ title, baseCrumb, parentLabel, parentHref }) {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split("/");
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path,
          href: "/" + linkPath.slice(0, i + 1).join("/"),
        };
      });

      const explicitParentCrumb = parentLabel
        ? [{ breadcrumb: parentLabel, href: parentHref || null }]
        : [];

      const legacyBaseCrumb = !parentLabel && baseCrumb
        ? [{ breadcrumb: baseCrumb, href: null }]
        : [];

      const finalCrumbs = [...explicitParentCrumb, ...legacyBaseCrumb, ...pathArray];

      setBreadcrumbs(finalCrumbs);
    }
  }, [router, baseCrumb, parentLabel, parentHref]);

  if (!breadcrumbs) {
    return null;
  }

  const breadcrumbsLength = breadcrumbs.length;

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ pb: 0 }}>
      <NextLink href="/" passHref legacyBehavior>
        <Link underline="none" color="text.secondary">
          Home
        </Link>
      </NextLink>
      {breadcrumbs.map((breadcrumb, i) => {
        const text = ConvertPathText(breadcrumb.breadcrumb);

        const isLast = breadcrumbsLength - 1 === i;

        if (isLast) {
          return (
            <Typography key={i} color="text.primary">
              {title ?? text}
            </Typography>
          );
        }

        if (!breadcrumb.href) {
          return (
            <Typography key={i} color="text.primary">
              {text}
            </Typography>
          );
        }

        return (
          <NextLink key={i} href={breadcrumb.href} passHref legacyBehavior>
            <Link underline="none">{text}</Link>
          </NextLink>
        );
      })}
    </Breadcrumbs>
  );
}
